import { Button, Flex, Icon } from '@wyz/ui';
import { useNavigate } from 'react-router';
import { PrivateComponent } from '~/common/components';
import { Trans } from '~/common/context';
import { FEATURES, ROLES } from '~/common/helpers';
import { useAccessControl } from '~/common/hooks';

const ErrorActions = ({
  resetErrorBoundary,
}: {
  resetErrorBoundary?: () => void;
}) => {
  const acl = useAccessControl();
  const navigate = useNavigate();
  return (
    <Flex
      alignItems='center'
      justifyContent='center'
      className='space-x-4 space-y-2 pt-4'
      wrap='wrap'
    >
      <PrivateComponent roles={[ROLES.ROLE_LIST_OFFERS]}>
        <Flex alignItems='center' justifyContent='center'>
          <Button
            id='purchase'
            variant='secondary'
            type='button'
            size='sm'
            onClick={() => {
              if (resetErrorBoundary) {
                resetErrorBoundary();
              }
              void navigate('/purchase');
            }}
          >
            <Icon icon={'shopping-cart'} className='me-2' />
            <Trans i18nKey='app.common.sidebar.new_order' />
          </Button>
        </Flex>
      </PrivateComponent>
      <PrivateComponent roles={[ROLES.ROLE_LIST_ORDERS]}>
        <Flex alignItems='center' justifyContent='center'>
          <Button
            id='orders'
            variant='secondary'
            type='button'
            size='sm'
            onClick={() => {
              if (resetErrorBoundary) {
                resetErrorBoundary();
              }
              void navigate('/purchase/orders');
            }}
          >
            <Icon icon={'shopping-cart'} className='me-2' />
            <Trans i18nKey='app.common.sidebar.orders' />
          </Button>
        </Flex>
      </PrivateComponent>
      {acl.isEnabledFeatures([FEATURES.QUOTE]) && (
        <PrivateComponent roles={[ROLES.ROLE_QUOTE_CREATE]}>
          <Flex alignItems='center' justifyContent='center'>
            <Button
              id='quotes'
              variant='secondary'
              type='button'
              size='sm'
              onClick={() => {
                if (resetErrorBoundary) {
                  resetErrorBoundary();
                }
                void navigate('/quotes');
              }}
            >
              <Icon icon={'quote'} className='me-2' />
              <Trans i18nKey='app.common.sidebar.quote.create' />
            </Button>
          </Flex>
        </PrivateComponent>
      )}
      <PrivateComponent roles={[ROLES.ROLE_CUSTOMER_LIST]}>
        <Flex alignItems='center' justifyContent='center'>
          <Button
            id='customers'
            variant='secondary'
            type='button'
            size='sm'
            onClick={() => {
              if (resetErrorBoundary) {
                resetErrorBoundary();
              }
              void navigate('/customers');
            }}
          >
            <Icon icon={'settings'} className='me-2' />
            <Trans i18nKey='app.common.sidebar.entities' />
          </Button>
        </Flex>
      </PrivateComponent>
    </Flex>
  );
};

export default ErrorActions;
